export default "__VITE_ASSET__1059160d__"